// alterado - revisado

import {
    SvgIcon,
} from '@material-ui/core'

import { ReactComponent as patrimonioImobilizadoSvg } from './patrimonioImobilizado.svg'

import { ReactComponent as receitaMensalSvg } from './receitaMensal.svg'

import { ReactComponent as recursosFinanceirosSvg } from './recursosFinanceiros.svg'

import { ReactComponent as seguroVidaSvg } from './seguroVida.svg'



export const SvgIconPatrimonioImobilizado = ( props ) => {
    return (
        <SvgIcon
            component={patrimonioImobilizadoSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconReceitaMensal = ( props ) => {
    return (
        <SvgIcon
            component={receitaMensalSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconRecursosFinanceiros = ( props ) => {
    return (
        <SvgIcon
            component={recursosFinanceirosSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconSeguroVida = ( props ) => {
    return (
        <SvgIcon
            component={seguroVidaSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}